import {Component, inject, input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormsModule} from '@angular/forms';
import { NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NumericUpDownComponent} from '../../../../shared/ui-components/numeric-up-down/numeric-up-down.component';
import {ProductCountPipe} from '../../../../shared/pipes/product-count.pipe';
import {
  BasketNewRequestDto,
  Client,
  StoreProductCountDto
} from '../../../../../api/client';
import {NzMessageService} from 'ng-zorro-antd/message';
import {BasketUiServiceService} from '../../../basket/basket-ui-service.service';
import {AuthService} from '../../../../services/authentication/auth.service.service';
import {MatDialog} from '@angular/material/dialog';
import {LoginPopUpComponent} from '../../../../shared/modal/login-pop-up/login-pop-up/login-pop-up.component';

@Component({
    selector: 'app-storage-table',
  imports: [
    FormsModule,
    NzInputNumberModule,
    NumericUpDownComponent,
    ProductCountPipe,

  ],
    templateUrl: './storage-table.component.html',
    standalone: true,
    styleUrl: './storage-table.component.scss'
})
export class StorageTableComponent implements OnInit, OnChanges{
  products = input<StoreProductCountDto[] | null>(null)
  private client = inject(Client);
  private authService = inject(AuthService);
  private basket: BasketNewRequestDto;
  public productQuantities: Map<string, number> = new Map();
  private notify = inject(NzMessageService);
  private basketService =inject(BasketUiServiceService);
  private dialog = inject(MatDialog);

  ngOnInit() {
    this.initializeProducts();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['products'] && this.products()) {
      this.initializeProducts();
    }
  }

  private initializeProducts() {
    if (this.products() && this.products().length > 0) {
      this.products().forEach((product, index) => {
        if (product.count === undefined || product.count === null) {
          product.count = 0;
        }
        const key = this.getProductKey(product, index);
        if (!this.productQuantities.has(key)) {
          this.productQuantities.set(key, 1);

        }
      })
    }
  }


  private getProductKey(product: any, index: number): string {
    return `${product.productId}_${product.storeId}_${index}`;
  }

  getQuantity(product: any, index: number): number {
    const key = this.getProductKey(product, index);
    return this.productQuantities.get(key) || 1;
  }

  setQuantity(product: any, index: number, value: number): void {
    const key = this.getProductKey(product, index);
    this.productQuantities.set(key, value);
  }

  addToCart(product: any, index: number): void {

    if (!this.authService.isAuthenticated()) {
        this.dialog.open(LoginPopUpComponent)
      } else {
      if (this.authService.authToast('Товар добавлен в корзину')) {
        const quantity = this.getQuantity(product, index);
        this.basket = {
          productId: product.productId,
          storeId: product.storeId,
          count: quantity,
        } as BasketNewRequestDto;

        if (quantity > 0 || quantity < this.basket.count) {
          this.client.basketNew_AddOrUpdate(this.basket).subscribe({next:()=> {this.basketService.initBasket()}});
        } else {
          this.notify.error('Произошла ошибка')
        }
      }
    }

  }

}
